export const RPC_AUTH_ENDPOINTS = {
    LOGIN: "/login",
    GET_INFLUENCER_PROFILE: "/get_influencer_profile",
};
